document.documentElement.classList.add("static-sacred-return");